import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import RegisterEntriesEditor from "./RegisterEntriesEditor";

const RegisterEntriesEditorPage = () => {
  const { registerId, entryId } = useParams();
  const navigate = useNavigate();
  const [entry, setEntry] = useState(null);
  const [loading, setLoading] = useState(true);

  const isNew = entryId === "new";

  const createEmptyEntry = () => ({
    _id: crypto.randomUUID(),
    registerId: registerId,
    name: "",
    type: "",
    description: "",
    isDefinition: false,
    references: [],
    classifications: [],
    amounts: [],
    dateTimes: [],
    createdDate: new Date().toISOString(),
  });

  useEffect(() => {
    const fetchEntry = async () => {
      if (isNew) {
        setEntry(createEmptyEntry());
        setLoading(false);
      } else {
        try {
          const res = await fetch(`https://registers.poc.mrc.ai/api/registerentries/${entryId}`);
          const data = await res.json();
          setEntry(data);
        } catch (error) {
          console.error("Error fetching register entry:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchEntry();
  }, [entryId, isNew, registerId]);

  const handleClose = () => navigate(`/registers/${registerId}`);

  if (loading) return <Spinner />;

  return <RegisterEntriesEditor entry={entry} onClose={handleClose} isNew={isNew} />;
};

export default RegisterEntriesEditorPage;
